import React from "react";
import { ArrowDownRight, ArrowUpRight } from "lucide-react";
import { useInView } from "../../hooks/useInView";

export default function DealerInventory({ dealers, date }) {
  const { ref, inView } = useInView();
  const maxUnits = Math.max(...dealers.map((d) => d.units), 80);

  return (
    <div ref={ref} className="dealer-block">
      <div className="dealer-head">Dealer inventory — {date}</div>
      <div className="dealer-list">
        {dealers.map((d, i) => {
          const up = d.change >= 0;
          return (
            <div key={d.name} className={`dealer-row ${d.low ? "low" : ""}`}>
              <div className="dealer-top">
                <span className="dealer-units">{d.units}</span>
                {d.low && <span className="dealer-tag">LOW STOCK</span>}
                <span className="dealer-name">{d.name}</span>
                <span className={`dealer-change ${up ? "up" : "down"}`}>
                  {up ? <ArrowUpRight size={13} /> : <ArrowDownRight size={13} />}
                  {up ? "+" : ""}{d.change}%
                </span>
              </div>
              <div className="dealer-bar">
                <div
                  className={`dealer-fill ${d.low ? "low" : up ? "up" : "mid"}`}
                  style={{ width: inView ? `${(d.units / maxUnits) * 100}%` : "0%", transitionDelay: `${i * 0.12}s` }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
